"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectorLocationAttributes$ = exports.SectorLocationAttributes$outboundSchema = exports.SectorLocationAttributes$inboundSchema = exports.SectorLocationAttributesAreaType$ = exports.SectorLocationAttributesAreaType$outboundSchema = exports.SectorLocationAttributesAreaType$inboundSchema = exports.SectorLocationAttributesAreaType = void 0;
exports.sectorLocationAttributesToJSON = sectorLocationAttributesToJSON;
exports.sectorLocationAttributesFromJSON = sectorLocationAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const locationpolygon_js_1 = require("./locationpolygon.js");
exports.SectorLocationAttributesAreaType = {
    PostcodeOutcode: "POSTCODE_OUTCODE",
    PostcodeSector: "POSTCODE_SECTOR",
    Postcode: "POSTCODE",
};
/** @internal */
exports.SectorLocationAttributesAreaType$inboundSchema = z.nativeEnum(exports.SectorLocationAttributesAreaType);
/** @internal */
exports.SectorLocationAttributesAreaType$outboundSchema = exports.SectorLocationAttributesAreaType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SectorLocationAttributesAreaType$;
(function (SectorLocationAttributesAreaType$) {
    /** @deprecated use `SectorLocationAttributesAreaType$inboundSchema` instead. */
    SectorLocationAttributesAreaType$.inboundSchema = exports.SectorLocationAttributesAreaType$inboundSchema;
    /** @deprecated use `SectorLocationAttributesAreaType$outboundSchema` instead. */
    SectorLocationAttributesAreaType$.outboundSchema = exports.SectorLocationAttributesAreaType$outboundSchema;
})(SectorLocationAttributesAreaType$ || (exports.SectorLocationAttributesAreaType$ = SectorLocationAttributesAreaType$ = {}));
/** @internal */
exports.SectorLocationAttributes$inboundSchema = z.object({
    agg_polygons: z.nullable(z.array(z.string())),
    area_type: z.nullable(exports.SectorLocationAttributesAreaType$inboundSchema),
    description: z.nullable(z.string()),
    description_1: z.nullable(z.string()),
    display_name: z.nullable(z.string()),
    epsg_27700_polygon: z.nullable(locationpolygon_js_1.LocationPolygon$inboundSchema),
    epsg_27700_polygon_simplified: z.nullable(locationpolygon_js_1.LocationPolygon$inboundSchema),
    epsg_4326_polygon: z.nullable(locationpolygon_js_1.LocationPolygon$inboundSchema),
    epsg_4326_polygon_simplified: z.nullable(locationpolygon_js_1.LocationPolygon$inboundSchema),
    name: z.nullable(z.string()),
    polygon_id: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "agg_polygons": "aggPolygons",
        "area_type": "areaType",
        "description_1": "description1",
        "display_name": "displayName",
        "epsg_27700_polygon": "epsg27700Polygon",
        "epsg_27700_polygon_simplified": "epsg27700PolygonSimplified",
        "epsg_4326_polygon": "epsg4326Polygon",
        "epsg_4326_polygon_simplified": "epsg4326PolygonSimplified",
        "polygon_id": "polygonId",
    });
});
/** @internal */
exports.SectorLocationAttributes$outboundSchema = z.object({
    aggPolygons: z.nullable(z.array(z.string())),
    areaType: z.nullable(exports.SectorLocationAttributesAreaType$outboundSchema),
    description: z.nullable(z.string()),
    description1: z.nullable(z.string()),
    displayName: z.nullable(z.string()),
    epsg27700Polygon: z.nullable(locationpolygon_js_1.LocationPolygon$outboundSchema),
    epsg27700PolygonSimplified: z.nullable(locationpolygon_js_1.LocationPolygon$outboundSchema),
    epsg4326Polygon: z.nullable(locationpolygon_js_1.LocationPolygon$outboundSchema),
    epsg4326PolygonSimplified: z.nullable(locationpolygon_js_1.LocationPolygon$outboundSchema),
    name: z.nullable(z.string()),
    polygonId: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        aggPolygons: "agg_polygons",
        areaType: "area_type",
        description1: "description_1",
        displayName: "display_name",
        epsg27700Polygon: "epsg_27700_polygon",
        epsg27700PolygonSimplified: "epsg_27700_polygon_simplified",
        epsg4326Polygon: "epsg_4326_polygon",
        epsg4326PolygonSimplified: "epsg_4326_polygon_simplified",
        polygonId: "polygon_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SectorLocationAttributes$;
(function (SectorLocationAttributes$) {
    /** @deprecated use `SectorLocationAttributes$inboundSchema` instead. */
    SectorLocationAttributes$.inboundSchema = exports.SectorLocationAttributes$inboundSchema;
    /** @deprecated use `SectorLocationAttributes$outboundSchema` instead. */
    SectorLocationAttributes$.outboundSchema = exports.SectorLocationAttributes$outboundSchema;
})(SectorLocationAttributes$ || (exports.SectorLocationAttributes$ = SectorLocationAttributes$ = {}));
function sectorLocationAttributesToJSON(sectorLocationAttributes) {
    return JSON.stringify(exports.SectorLocationAttributes$outboundSchema.parse(sectorLocationAttributes));
}
function sectorLocationAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SectorLocationAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SectorLocationAttributes' from JSON`);
}
//# sourceMappingURL=sectorlocationattributes.js.map